var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rb-product-tile__content" },
    [
      _vm.isLoading
        ? _c("rb-dummy-skeleton", {
            staticClass: "rb-product-tile__name --content",
          })
        : _c(
            "h2",
            {
              staticClass: "rb-product-tile__name --type",
              attrs: { "data-mnt-product-name": _vm.selectedVariant.name },
            },
            [_vm._v("\n    " + _vm._s(_vm.selectedVariant.name) + "\n  ")]
          ),
      _vm._v(" "),
      _vm.isLoading
        ? _c("rb-dummy-skeleton", {
            staticClass: "rb-product-tile__price --content",
          })
        : _c("div", { staticClass: "rb-product-tile__price --type" }, [
            _c("div", { staticClass: "rb-product-tile__price-container" }, [
              _c(
                "span",
                {
                  staticClass: "rb-product-tile__price--original",
                  class: {
                    "rb-product-tile__price--line-through":
                      _vm.currentPromotion.discountedPrice,
                  },
                  attrs: {
                    "data-mnt-product-fullprice": _vm.selectedVariant.price,
                  },
                },
                [_vm._v(_vm._s(_vm.selectedVariant.price))]
              ),
              _vm._v(" "),
              _vm.currentPromotion.discountedPrice
                ? _c(
                    "span",
                    {
                      staticClass: "rb-product-tile__price--discounted",
                      attrs: {
                        "data-mnt-product-price": _vm.selectedVariant.price,
                      },
                    },
                    [_vm._v(_vm._s(_vm.currentPromotion.discountedPrice))]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.isBrazil &&
            _vm.areInstallmentsVisible &&
            !_vm.isOpticsNotSellableInCountry
              ? _c(
                  "div",
                  { staticClass: "rb-product-tile__price-instalments" },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.BRASIL_INSTALLMENTS) +
                        " " +
                        _vm._s(_vm.splitPrice) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
      _vm._v(" "),
      _c("rb-product-tile-attributes", {
        attrs: {
          attributes: _vm.selectedVariant.attributesPriority,
          loading: _vm.isLoading,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }